import EstadoDeudaCombobox from "./EstadoDeudaCombobox.vue";

export {EstadoDeudaCombobox}
export default EstadoDeudaCombobox
